import React from "react";
import {PrivacyWrapper, PrivacyTitle, Text, LoginC, PrivacyDescription, Subtitle} from "../Styles";
import {Link} from "react-router-dom";
import {routes} from "../../Constants/Constants";

const Privacy = () => {
  return (
    <div>
      <LoginC>
        <Text>
          <Link to={`${routes.App.Home}`} style={{color: 'white', textDecoration: 'blink'}}>Shtëpia+ </Link>
        </Text>
      </LoginC>
     <PrivacyWrapper>
       <PrivacyTitle style={{marginTop:'50px'}}><strong>Privatësia</strong></PrivacyTitle>
       <Subtitle><strong>Krijimi i një llogarie</strong></Subtitle>
       <PrivacyDescription>Për të përdorur këtë shërbim, juve ju nevojitet që të krijoni një llogari.
         Për të krijuar një llogari, mjafton që juve të keni një llogari ekzistuese në një nga sherbimet e palëve të treta që neve suportojmë - aktualisht suportohet vetëm Sign In with Google.</PrivacyDescription>
       <PrivacyDescription>Neve nuk do t'ju kërkojmë asnjë të dhënë personale, perjashtim të emailit me të cilin jeni të regjistruar tek sherbimi i palës së tretë.
         Ky email është i nevojshëm pasi shërben si identifikues për llogarinë, edhe siguron qe llogaria është unike.</PrivacyDescription>
       <Subtitle><strong>Politika e privatësisë </strong></Subtitle>
       <PrivacyDescription>Me përdorimin e këtij shërbimi, ju pranoni që ne të përdorim adresen tuaj email vetëm për qëllim identifikimi të llogarisë suaj personale tek shërbimi ynë dhe për asnjë lloji arsyeje tjetër.
         Ky shërbim nuk mbledh dhe nuk përpunon asnjë lloji tjeter të dhëne personale.</PrivacyDescription>
       <Subtitle><strong>Kontakt</strong></Subtitle>
       <PrivacyDescription>Ju mund të na kontaktoni në çdo kohë në adresën tonë email: info@shtepiaplus.com</PrivacyDescription>
     </PrivacyWrapper>
    </div>
  );
};

export default Privacy;